// AUTO-GENERATED by scripts/build-nav.mjs — do not edit by hand.
// Run `node scripts/build-nav.mjs` (or `npm run build-nav`) to regenerate.
import type { Navigation } from "zudoku";

export const ecommerceApiNav: Navigation = [
  {
    "type": "category",
    "label": "数据查询",
    "collapsible": true,
    "collapsed": false,
    "items": [
      {
        "type": "link",
        "to": "/api/数据查询-1-商品数据",
        "label": "商品数据"
      },
      {
        "type": "link",
        "to": "/api/数据查询-4-店铺数据",
        "label": "店铺数据"
      },
      {
        "type": "link",
        "to": "/api/数据查询-2-达人数据",
        "label": "达人数据"
      },
      {
        "type": "link",
        "to": "/api/数据查询-3-视频数据",
        "label": "视频数据"
      },
      {
        "type": "link",
        "to": "/api/数据查询-6-直播数据",
        "label": "直播数据"
      },
      {
        "type": "link",
        "to": "/api/数据查询-5-广告与创意情报",
        "label": "广告与创意情报"
      },
      {
        "type": "link",
        "to": "/api/数据查询-7-亚马逊数据",
        "label": "亚马逊数据"
      }
    ]
  },
  {
    "type": "category",
    "label": "内容制作",
    "collapsible": true,
    "collapsed": false,
    "items": [
      {
        "type": "link",
        "to": "/api/内容制作-1-ai-视频",
        "label": "AI 视频"
      },
      {
        "type": "link",
        "to": "/api/内容制作-2-ai-图片",
        "label": "AI 图片"
      },
      {
        "type": "link",
        "to": "/api/内容制作-3-ai-文案",
        "label": "AI 文案"
      },
      {
        "type": "link",
        "to": "/api/内容制作-4-ai-分析",
        "label": "AI 分析"
      },
      {
        "type": "link",
        "to": "/api/内容制作-5-ai-画布",
        "label": "AI 画布"
      },
      {
        "type": "link",
        "to": "/api/内容制作-6-视频编辑",
        "label": "视频编辑"
      }
    ]
  },
  {
    "type": "category",
    "label": "社媒管理",
    "collapsible": true,
    "collapsed": false,
    "items": [
      {
        "type": "link",
        "to": "/api/社媒管理-1-账号管理",
        "label": "账号管理"
      },
      {
        "type": "link",
        "to": "/api/社媒管理-2-视频发布",
        "label": "视频发布"
      },
      {
        "type": "link",
        "to": "/api/社媒管理-3-视频管理",
        "label": "视频管理"
      },
      {
        "type": "link",
        "to": "/api/社媒管理-4-评论互动",
        "label": "评论互动"
      },
      {
        "type": "link",
        "to": "/api/社媒管理-5-数据分析",
        "label": "数据分析"
      },
      {
        "type": "link",
        "to": "/api/社媒管理-6-创作工具",
        "label": "创作工具"
      },
      {
        "type": "link",
        "to": "/api/社媒管理-7-tiktok-shop",
        "label": "TikTok Shop"
      },
      {
        "type": "link",
        "to": "/api/社媒管理-8-私信管理",
        "label": "私信管理"
      },
      {
        "type": "link",
        "to": "/api/社媒管理-9-店铺经营",
        "label": "店铺经营"
      }
    ]
  },
  {
    "type": "category",
    "label": "广告营销",
    "collapsible": true,
    "collapsed": false,
    "items": [
      {
        "type": "link",
        "to": "/api/广告营销-1-广告账户",
        "label": "广告账户"
      },
      {
        "type": "link",
        "to": "/api/广告营销-2-常规投放",
        "label": "常规投放"
      },
      {
        "type": "link",
        "to": "/api/广告营销-3-gmv-max",
        "label": "GMV MAX"
      },
      {
        "type": "link",
        "to": "/api/广告营销-4-诊断与复盘",
        "label": "诊断与复盘"
      },
      {
        "type": "link",
        "to": "/api/广告营销-5-投放准备",
        "label": "投放准备"
      },
      {
        "type": "link",
        "to": "/api/广告营销-6-受控创建",
        "label": "受控创建"
      }
    ]
  },
  {
    "type": "category",
    "label": "小匠Agent",
    "collapsible": true,
    "collapsed": false,
    "items": [
      {
        "type": "link",
        "to": "/api/小匠agent-1-对话",
        "label": "对话"
      },
      {
        "type": "link",
        "to": "/api/小匠agent-2-会话与报告",
        "label": "会话与报告"
      }
    ]
  },
  {
    "type": "link",
    "to": "/api/异步任务",
    "label": "异步任务"
  },
  {
    "type": "link",
    "to": "/api/文件上传",
    "label": "文件上传"
  },
  {
    "type": "link",
    "to": "/api/账户",
    "label": "账户"
  }
];

export const llmApiNav: Navigation = [
  {
    "type": "link",
    "to": "/llm-api/对话补全",
    "label": "对话补全"
  },
  {
    "type": "link",
    "to": "/llm-api/图片生成",
    "label": "图片生成"
  },
  {
    "type": "link",
    "to": "/llm-api/视频生成",
    "label": "视频生成"
  },
  {
    "type": "link",
    "to": "/llm-api/异步任务",
    "label": "异步任务"
  },
  {
    "type": "link",
    "to": "/llm-api/模型列表",
    "label": "模型列表"
  }
];
